export default __webpack_public_path__ + "static/media/close-yellow.a96f1938.svg";